import departmentsController from './departmentsController'

export default departmentsController



// WEBPACK FOOTER //
// ../src/controllers/departmentsController/index.js